// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2l3zE","location":"Header_location__3PDUt"};